import { render, staticRenderFns } from "./RekognitionForm.vue?vue&type=template&id=c8a82baa&scoped=true&"
import script from "./RekognitionForm.vue?vue&type=script&lang=js&"
export * from "./RekognitionForm.vue?vue&type=script&lang=js&"
import style0 from "./RekognitionForm.vue?vue&type=style&index=0&id=c8a82baa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a82baa",
  null
  
)

export default component.exports